module.exports = __webpack_public_path__ + "baee339648ef24422d9ce327064bff95.svg";